// Copyright (c) 2017 Deere & Company

import {buildCurrency} from '../../../shared/services/build-number';

export const getAmountWithCurrency = (amount, currency) => isNaN(amount) ? '' : `${buildCurrency(amount)} ${currency.key}`;



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/services/partial-debit-helper.js